<template>
  <div>
    <driver-dashboard
      v-if="hasPermission('dashboards.driver')"
    ></driver-dashboard>
    <default-dashboard v-else></default-dashboard>
  </div>
</template>

<script>
import DefaultDashboard from '@/components/Dashboards/DefaultDashboard';
import DriverDashboard from '@/components/Dashboards/DriverDashboard';

export default {
  components: {
    DefaultDashboard,
    DriverDashboard
  }
};
</script>
